<template>
	<div class="banners__description-block-content">
		<div class="banners__description-block-item">
			<p v-if="block.title" class="banners__description-block-item-title">
				{{ $rt(block.title) }}
			</p>
			<ul class="banners__description-block-item-list">
				<li v-for="(format, index) in block.chips" :key="index">
					<button type="button" class="banners__description-btn disabled">
						{{ $rt(format) }}
					</button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup lang="ts">
	const props = defineProps<{
		block: {
			title?: string
			chips?: string[]
		}
	}>()

	const block = computed(() => ({
		title: props.block.title,
		chips: props.block.chips ?? [],
	}))
</script>

<style lang="scss" scoped>
	.banners__description-block-content {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}
	.banners__description-block-item {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.banners__description-block-item-list {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}
	.banners__description-btn {
		padding: 8px;
		border: 1.5px solid var(--primary);
		border-radius: 50px;
		transition: 0.3s background-color;
		&.disabled {
			border-color: var(--gray400);
		}
		&:hover {
			background-color: var(--primary-hover);
		}
	}
</style>
